// extracted by mini-css-extract-plugin
module.exports = {"card":"AboutMe_card__1kMqE"};